// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aa1d0533","388":"0457d5c7","453":"0a1f87a9"}[chunkId] + ".chunk.js";
};